import { render, staticRenderFns } from "./CustomerFormAddress.vue?vue&type=template&id=1913da7a&"
import script from "./CustomerFormAddress.vue?vue&type=script&lang=js&"
export * from "./CustomerFormAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports